import Headroom from 'headroom.js';
import Menu from './menu-item';

const header = document.querySelector('header'),
    cart = document.querySelector('.cart'),
    classNameCart = 'is-unpin',
    btnJs = document.querySelectorAll('.header-right-group .btn-js'),
    btnMenuDropDown = document.querySelectorAll('.btn-js .dropdown-menu'),
    classNamebtnMenu = 'show';

function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
}

/*
function addClass(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!hasClass(el, className)) el.className += ' ' + className;
}
*/

function removeClass(el, className) {

    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
}


function btnRemove() {
    for (var i = 0; i < btnJs.length; i++) {
        if (hasClass(btnJs[i], classNamebtnMenu)) removeClass(btnJs[i], classNamebtnMenu);
    }

    for (var i = 0; i < btnMenuDropDown.length; i++) {
        if (hasClass(btnMenuDropDown[i], classNamebtnMenu)) removeClass(btnMenuDropDown[i], classNamebtnMenu);
    }
}


if (window.innerWidth >= 992) {
    var offset = 80;
} else {
    var offset = 60;
}

if (header) {
    const headerSticky = new Headroom(header, {
        offset: offset,
        //tolerance: 0,
        tolerance: {
            down: 0,
            up: 0
        },
        classes: {
            initial: "headroom",
            pinned: "headroom--pinned",
            unpinned: "headroom--unpinned",
        },
        onPin: () => {

            btnRemove();

        },
        onUnpin: () => {
            if (window.innerWidth >= 992) {
                Menu.hide();
            } else {
                return false
            }

            btnRemove();

        },
        onTop: () => {
            if (cart) {
                if (cart.classList) {
                    cart.classList.remove(classNameCart);
                } else {
                    cart.classNameCart = cart.classNameCart.replace(new RegExp('(^|\\b)' + classNameCart.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                }
            }

            btnRemove();

        },
        onNotTop: () => {
            if (cart) {
                if (cart.classList) {
                    cart.classList.add(classNameCart);
                } else {
                    cart.classNameCart += ' ' + classNameCart;
                }
            }

            btnRemove();

        }
    });

    headerSticky.init();
}


// WEBPACK FOOTER //
// ./resources/assets/js/sticky-header.js